// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardLogoComponent_card-logo-container__JVefc {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  width: 70px;
}
.CardLogoComponent_card-logo-container__JVefc.CardLogoComponent_credit-card-logo-container__3mbRm {
  width: 40%;
  margin: 0% 4%;
}
.CardLogoComponent_card-logo-container__JVefc.CardLogoComponent_debit-card-logo-container__mBeHy {
  width: 19%;
  margin: 0% 1%;
}
.CardLogoComponent_card-logo-container__JVefc.CardLogoComponent_bbva-debit-card-logo-container__1ni06 {
  display: inline-block;
  text-align: center;
  width: 19%;
  height: 40px;
  margin: 0px 1% 0px 1%;
}
.CardLogoComponent_card-logo-container__JVefc.CardLogoComponent_bbva-debit-card-logo-container__1ni06 img {
  margin: 0em 0 0.5em 0em;
  max-width: 90%;
  height: 70%;
}
.CardLogoComponent_card-logo-container__JVefc img {
  width: 80%;
  max-height: 90%;
  margin: 0.5em 0.2em;
}`, "",{"version":3,"sources":["webpack://./src/views/Payment/PaymentSteps/CardLogoComponent.module.scss"],"names":[],"mappings":"AAIA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAHJ;AAKI;EACI,UAAA;EACA,aAAA;AAHR;AAKI;EACI,UAAA;EACA,aAAA;AAHR;AAKI;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;AAHR;AAIQ;EACI,uBAAA;EACA,cAAA;EACA,WAAA;AAFZ;AAMI;EACI,UAAA;EACA,eAAA;EACA,mBAAA;AAJR","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n\n.card-logo-container {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    height: 70px;\n    width: 70px;\n\n    &.credit-card-logo-container {\n        width: 40%;\n        margin: 0% 4%;\n    }\n    &.debit-card-logo-container {\n        width: 19%;\n        margin: 0% 1%;\n    }\n    &.bbva-debit-card-logo-container {\n        display: inline-block;\n        text-align: center;\n        width: 19%;\n        height: 40px;\n        margin: 0px 1% 0px 1%;\n        img {\n            margin: 0em 0  0.5em 0em;\n            max-width: 90%;\n            height: 70%;\n        }\n    }\n\n    img {\n        width: 80%;\n        max-height: 90%;\n        margin: 0.5em 0.2em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card-logo-container": `CardLogoComponent_card-logo-container__JVefc`,
	"credit-card-logo-container": `CardLogoComponent_credit-card-logo-container__3mbRm`,
	"debit-card-logo-container": `CardLogoComponent_debit-card-logo-container__mBeHy`,
	"bbva-debit-card-logo-container": `CardLogoComponent_bbva-debit-card-logo-container__1ni06`
};
export default ___CSS_LOADER_EXPORT___;
